import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { useTranslation } from 'react-i18next';
import { QuickLinks } from '../blocks/all-blocks';
import TagFinder from '../components/TagFinder';
import Button from '../components/Button';
import posts from '../posts';
import '../styles/post.css';

const PostPage = () => {
  const { slug } = useParams();
  const { t } = useTranslation();
  const post = posts.find(p => p.slug === slug);

  if (!post) {
    return <Navigate to="404" replace />;
  }

  const quickLinks = [
    { name: t('quickLinks.knowledge'), url: '/knowledge' },
    { name: t('quickLinks.travel'), url: '/travel' },
    { name: t('quickLinks.aboutMe'), url: '/me' }
  ];

  return (
    <div className="cont-body">
      <section className="bl-hero">
        <div className="hero-container">
          <div className="hero-content post-hero-content">
            <div className="post-meta">
              <p>{post.date}</p>
              <TagFinder num={post.tags} />
            </div>
            <h1 className="hero-title">{post.title}</h1>
          </div>
        </div>
      </section>
      <section className="bl-post-body section-block">
        <div className="post-body-container">
          <ReactMarkdown>{post.content}</ReactMarkdown>
        </div>
        <Button url="/notes" name="← Back to notes" className="back-to-notes" />
      </section>
      <QuickLinks list={quickLinks} />
    </div>
  );
};

export default PostPage;
